// New-conversation nudge banner (ipa-training-mode).
// Rendered when the orchestrator signals (via the `nudge` SSE event) that a
// fresh conversation would likely produce a better answer than continuing the
// current thread. Dismissible; never blocks chat. See constants/nudge.ts for
// the locked cross-repo contract.
import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import { Button } from '../../../../../../ui/atoms/Button/Button';
import './NudgeBannerStyles.scss';
const BASE_CLASS = 'ai-nudge-banner';
const I18N_NAMESPACE = 'features.ai_chat_widget.nudge_banner';
export function NudgeBanner({ message, onAccept, onDismiss }) {
    return (React.createElement("div", { className: BASE_CLASS, role: "status" },
        React.createElement("i", { className: `${BASE_CLASS}__icon fa-light fa-sparkles`, "aria-hidden": "true" }),
        React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__message` }, message),
        React.createElement("div", { className: `${BASE_CLASS}__actions` },
            React.createElement(Button, { variant: "primary", className: `${BASE_CLASS}__accept-btn`, onClick: onAccept }, translate('accept', { namespace: I18N_NAMESPACE })),
            React.createElement("button", { type: "button", className: `${BASE_CLASS}__dismiss-btn`, "aria-label": translate('dismiss', { namespace: I18N_NAMESPACE }), onClick: onDismiss },
                React.createElement("i", { className: "fa-light fa-xmark", "aria-hidden": "true" })))));
}
